
import ThirdPartyProviderDetailInfo from "./ThirdPartyProviderDetailInfo";
import ThirdPartyProviderNotesForm from "./ThirdPartyProviderNotes";
import ThirdPartyProviderCertificateNotesForm from "./ThirdPartyProviderCeritifcateNotes";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";


const ThirdPartyProviderDetailsForm = () => {
    return (

        <div className="md:grid grid-cols-9 gap-4">

            <div className="col-span-5 space-y-4">
                <ThirdPartyProviderDetailInfo isReadOnly={hasPermission(["HOATPP-U"]) === false} />
            </div>


            <div className="col-span-4">
                <ThirdPartyProviderNotesForm />
                {hasPermission(["CRTNOT-V"]) &&
                    <ThirdPartyProviderCertificateNotesForm />}

            </div>
        </div>
    );
};

export default ThirdPartyProviderDetailsForm;